import { AbstractControl } from '@angular/forms';
import { map } from 'rxjs/operators';

export function withAbstractControl<T>(control: AbstractControl) {
	return {
		setValue: (
			value: T,
			options: { emitEvent: boolean } = { emitEvent: false }
		): void => {
			control.setValue(value, options);
		},
		valueChanges: control.valueChanges.pipe(
			map((v: T) => ({ ...v, pageNumber: 0 }))
		),
	};
}
